import { GLOB } from "src/util/Glob";

const useReadonly = (ignoreReadonly?: boolean, disabled?: boolean) => {
  const { readonly } = GLOB.userInfo ?? {};
  return {
    isDisabled: (!ignoreReadonly && readonly) || disabled
  }
}

export default useReadonly;